import MALKA_EXT_1 from "./MALKA_EXT_1";
export default {
  MALKA_EXT_1,
};
